module.exports = __webpack_public_path__ + "static/media/plan-oferta-wom-mas-450gb.216c47f4.svg";